import React, { useState } from 'react'
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore'

import { db } from '../../FirebaseInit'
import { useToast } from '../../context/ToastContext'
import { STATUSES } from '../../utils/tickets/ticket-logic'
import CloseTicketModal from './CloseTicketModal'

// StatusSelect (design: Pages and UI components; Req 6.1, 6.2, 6.3)
//
// Admin status selector restricted to the allowed STATUSES set. Non-'Closed'
// changes write directly; selecting 'Closed' opens the CloseTicketModal so a
// closure reason is captured. Non-admins get a read-only status label (their
// close affordance lives in a separate button on the detail page).
const StatusSelect = ({ ticketId, status, admin, onChanged = () => {} }) => {
  const { showToast } = useToast()
  const [saving, setSaving] = useState(false)
  const [showCloseModal, setShowCloseModal] = useState(false)

  // Non-admins never see the control; show the current status read-only.
  if (!admin) {
    return <span className='text-sm font-medium text-gray-700'>{status}</span>
  }

  const handleChange = async (event) => {
    const newStatus = event.target.value
    if (newStatus === status) return

    // Closing requires a reason — route through the modal.
    if (newStatus === 'Closed') {
      setShowCloseModal(true)
      return
    }

    setSaving(true)
    try {
      await updateDoc(doc(db, 'tickets', ticketId), {
        status: newStatus,
        statusChangedAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      })
      showToast('Status updated', 'green')
      onChanged(newStatus)
    } catch (err) {
      console.error('Failed to update status:', err)
      showToast('Failed to update status', 'red')
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <select
        value={status}
        onChange={handleChange}
        disabled={saving}
        className='rounded border border-gray-300 px-2 py-1 text-sm'
      >
        {STATUSES.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>

      {showCloseModal && (
        <CloseTicketModal
          ticketId={ticketId}
          onClose={() => setShowCloseModal(false)}
          onClosed={() => onChanged('Closed')}
        />
      )}
    </>
  )
}

export default StatusSelect
